import React, {ReactElement} from "react";
import {Container} from "./HeaderStatusBar.styles";

interface HeaderStatusBarProps {
    buttonClassName?: string
    withArrow?: boolean
    buttonText?: string
    onButton?: (e: any) => void
}

const HeaderStatusBar = ({buttonClassName = '', withArrow = false, buttonText, onButton}: HeaderStatusBarProps): ReactElement => {
    const classname = "yellowBackButton" + (buttonClassName.length
        ? ` ${buttonClassName}`
        : '')
    return <Container>
        {buttonText?.length && <button
            onClick={onButton}
            className={classname}>
            {withArrow && <img
                className="arrowIcon"
                alt=""
                src={"img/arrowLeftYellow.svg"}
            />}
            <span>{buttonText}</span>
        </button>}
        <img
            className="tempstars-logo-icon"
            alt="tempstars-logo-icon"
            src={"img/logoBlue.svg"}
        />
    </Container>
}

export default HeaderStatusBar;